<template>
    <footer class="footer">
        <b-container class="text-white h-100 d-flex justify-content-between flex-column pb-100 position-relative footer-container">
            <div class="px-5">
              <p class="gotham-book mt-140">CONTACT/</p>
              <div class="freight-text-big-pro-book h5 mt-4">
                LET'S WORK TOGETHER
              </div>
              <p class="h2 gotham-bold mt-100 ga-pink">#1063</p>
              <a href="tel:416-783-3311" class="text-white">416/783/3311</a>
              <br>
              <a href="mailto:letsmeet@1063eglinton.ca" class="text-white">letsmeet@1063eglinton.ca</a>
              <br>
              <span class="d-block mt-3"></span>
                Marci MacEachern
                <br>
                <a href="mailto:marci@1063eglinton.ca" class="text-white" target="_blank">
                    marci@guidelinesad.com
                </a>
                <!--  -->
                <span class="d-block mt-3"></span>
                Flavio Cappella
                <br>
                <a href="mailto:flavio@1063eglinton.ca" class="text-white" target="_blank">
                    flavio@guidelinesad.com
                </a>
              <br>
              <br>
              <a href="https://goo.gl/maps/XcCJM6YScs7Up4sV6" target="_blank" class="text-white">
                1063 eglinton avenue west
                <br>
                toronto, ontario m6c 2c9
              </a>
               
              
              <div class="text-white mt-4">
                <span 
                class="text-underline"
                role="button" 
                @click="accessibility_visible = !accessibility_visible" style="text-decoration: underline">Accessibility</span>
                <div class="accessibility-section mt-2" 
                :class="{ 'accessibility-active' : accessibility_visible == true }">
                  <div class="bodycopy-text gotham-book">
                    All documents and policies required under the Customer Service Standard, Ontario Regulation 429/07, are available to the public by requesting them from our office or April Casali (Director of Human Resources)
                    <div>-</div>
                    <a href="tel:416-783-3311" class="text-white">416.783.3311</a>
                    |
                    <a href="mailto:april@guidelinesad.com" class="text-white">april@guidelinesad.com</a>
                    <div>-</div>
                    <a href="https://guidelinesad.com/files/Accessibility-Feedback-Form.pdf" target="_blank" class="text-white">
                      DOWNLOAD FEEDBACK FORM
                    </a>
                    <div>-</div>
                    <a href="https://guidelinesad.com/files/Access-Standard-Policy-2026-final.doc" target="_blank" class="text-white">
                      ACCESS STANDARD POLICY 2026
                    </a>
                    <div>-</div>
                    <a href="https://guidelinesad.com/files/Access-Standard-Service-Plan-2026.doc" target="_blank" class="text-white">
                      ACCESS STANDARD SERVICE PLAN 2026
                    </a>
                    <div>-</div>
                    <a href="https://guidelinesad.com/files/Scan_05192026111739.pdf" target="_blank" class="text-white">
                      ACCESS STANDARD COMPLIANCE REPORT 2026
                    </a>
                    <div>-</div>
                    <span class="gotham-bold">
                      Request feedback form in an alternate format
                    </span>
                    <br>
                    Email us at <a href="mailto:april@guidelinesad.com" class="text-white">april@guidelinesad.com</a> if you need the form in an alternate format.
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-social">
              <div class="icons">
                <a href="https://www.facebook.com/guidelinesad/" target="_blank">
                <nuxt-img loading="lazy" provider="static" format="webp"
                    src="/img/ga-fb-pink.png"
                    alt="Facebook"
                    class="w-100 social-icon"
                    width="30"
                    height="30"
                    sizes="lg:30px"
                />
                </a>
                <a href="https://www.tiktok.com/@guidelines1063" target="_blank">
                <nuxt-img loading="lazy" provider="static" format="webp"
                    src="/img/ga-tt-pink.png"
                    alt="Tik Tok"
                    class="w-100 social-icon"
                    width="30"
                    height="30"
                    sizes="lg:30px"
                />
                </a>
                <a href="https://www.instagram.com/1063_guidelines/" target="_blank">
                <nuxt-img loading="lazy" provider="static" format="webp"
                    src="/img/ga-ig-pink.png"
                    alt="Instagram"
                    class="w-100 social-icon"
                    width="30"
                    height="30"
                    sizes="lg:30px"
                />
                </a>
                <a href="https://www.linkedin.com/company/guidelines-advertising-ltd/mycompany/?viewAsMember=true" target="_blank">
                <nuxt-img loading="lazy" provider="static" format="webp"
                    src="/img/ga-li-pink.png"
                    alt="Linked In"
                    class="w-100 social-icon"
                    width="30"
                    height="30"
                    sizes="lg:30px"
                />
                </a>
              </div>
            </div>
        </b-container>
    </footer>
</template>

<script>

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
    data() {
        return {
            footerParallax: null,
            footerST: null,
            accessibility_visible: false
        }
    },
    components: {
        TickerTextSingleLine: () => import('@/components/TickerTextSingleLine'),
        TickerTextMultipleLines: () => import('@/components/TickerTextMultipleLines'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
      this.$nextTick(() => {
        ScrollTrigger.refresh();
        setTimeout(() => {
          this.footerParallax = gsap;
          this.footerParallax.set('.footer-container', { yPercent: -50 });
          this.footerParallax.timeline({ paused:true });

          this.footerST = ScrollTrigger.create({  
              trigger: '.conclusion',
              start: 'bottom bottom',
              end: '+=100%',
              animation: this.footerParallax.to('.footer-container', { yPercent: 0, ease: 'none' }),
              scrub: true,  
          })
        }, 500)
      })
    },
    beforeDestroy() {
      setTimeout(() => {
          this.footerST.kill();
          // this.footerParallax.kill();
        }, 500)
    }
}
</script>

<style scoped lang="scss">
footer {
  min-height: 75vh;
  width: 100vw;
  background-color: #000;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 767px) {
    min-height: 100%;
  }

  .footer-container {
    height: 100%;
    display: flex;

    @media screen and (max-width: 767px) {
      height: 100%;
    }
  }

  .footer-social {
    display: flex;
    align-items: center;
    transform: rotate(-90deg) translate(0, -100%);
    transform-origin: 100% 0;
    position: absolute;
    top: 119px;
    right: 0;
  }

  .share {
    display: flex;
    align-items: center;
    color: #ff56b1;

    .social-line {
      width: 100px;
      height: 2px;
      background: #ff56b1;
    }
  }

  .icons {
    padding: 20px;
    .social-icon {
      max-width: 30px;
      transform: rotate(-270deg);
    }

  }

  .accessibility-section {
    max-width: 600px;
    height: 0;
    visibility: hidden;
    opacity: 0;
    max-height: 0;
    transition: 0.3s ease-in-out;
  }

  .accessibility-active {
    height: 100%;
    visibility: visible;
    opacity: 1;
    max-height: 800px;
    transition: 0.3s ease-in-out;
  }
}


</style>